<template>
  <div class="graph">
    <div class="graph__header flex">
      <div class="graph__title">
        Источники
      </div>
      <div v-if="items?.length > 0" class="graph__color-info flex vertical-center" style="font-size: 14px">
        <div style="gap: 6px; margin-right: 16px" class="flex vertical-center">
          <div style="border-radius: 50%; height: 8px; width: 8px" :style="{backgroundColor: colorBgCol[1]}"></div>
          Отклики
        </div>
        <div style="gap: 6px" class="flex vertical-center">
          <div style="border-radius: 50%; height: 8px; width: 8px" :style="{backgroundColor: colorBgCol[0]}"></div>
          Трудоустроено
        </div>
      </div>
      <div class="graph__link"></div>
    </div>

    <div class="graph__description">Кандидаты</div>

    <div v-if="items?.length > 0" class="graph__content">

      <div class="graph__graph" >
        <canvas style="height: 328px; width: 790px" ref="barChart"></canvas>
      </div>
    </div>

    <div style="height: 280px" class="no-data" v-else>
      Нет данных
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";


const props = defineProps({
  items: [Object, Array],
})

const app_name = computed(() => {
  return process.env.VUE_APP_PRODUCT_NAME
})
const colorBgCol = computed(() => {
  if (app_name.value === "PROTEKTOR") {
    return ['#B99521', '#B995211A']
  }
  return ['#0086B2', '#D6EBF2']
})

let graphData = computed(() => {
  let graph = {
    labels: [],
    datasets: [
      {
        label: 'Темная',
        data: [],
        backgroundColor: colorBgCol.value[0],
        borderRadius: 16,
        borderWidth: 0,
        barThickness: 64,
      },
      {
        label: 'Светлая',
        data: [],
        backgroundColor: colorBgCol.value[1],
        borderRadius: 16,
        borderWidth: 0,
        barThickness: 64,
      }
    ]
  }


  props.items?.forEach((el, index) => {
    graph.labels.push(el.title)
    graph.datasets[0].data.push(el.hired_count === 0 ? 0 : el.hired_count + 15)
    graph.datasets[1].data.push(el.applied_count === 0? 0 : el.applied_count + 20)
  })
  return graph
})


const getBarChart = () => {
  if (barChart.value && window.Chart && window.ChartDataLabels) {
    // Регистрируем плагин (важно при использовании CDN)
    Chart.register(ChartDataLabels);

    new Chart(barChart.value.getContext('2d'), {
      type: 'bar',
      data: graphData.value,
      options: {
        responsive: true,
        hover: {
          mode: null,
          animationDuration: 0 // Отключает анимацию при наведении
        },
        scales: {
          x: {
            stacked: true,
            // barPercentage: 0.4, // Уменьшаем для большего расстояния (по умолч. 0.9)
            // categoryPercentage: 0.8, // Уменьшаем для большего расстояния между группами (по умолч. 0.8)
            grid: {
              display: false,
            },

          },
          y: {
            beginAtZero: true,
            border: {
              display: false // Полностью скрыть ось
            },
            grid: {
              color: '#F4F5F7', // Цвет сетки (полос)
              drawBorder: false, // Убирает вертикальную линию слева
            },
            ticks: {
              stepSize: 90, // Шаг значений на оси Y
              color: '#8F9CAC',
              padding: 14,
              callback: function(value) {
                if(value === 0) return 0
                return value - 10; // Отнимаем 40 от каждого значения на оси Y
              }
            }
          }
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top',
            color: (context) => context.datasetIndex === 0 ? '#FFF' : '#1E3959',
            font: {
              weight: '',
              size: 14
            },
            formatter: (value, context) => `${context.datasetIndex % 2 === 0 ? value === 0 ? '' : value-15 : value === 0 ? '' : value-20}`,
            // Показывать значения только для темных колб

            offset: -25,      // Сдвигаем текст вниз (внутрь колбы)
            padding: {
              top: 5         // Дополнительный отступ сверху
            }
          },
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        // Настройки ширины колб
        categoryPercentage: 30,
        barPercentage: 30
      },
      plugins: [ChartDataLabels] // Явное подключение плагина
    });
  }
};

const route = useRoute();
const barChart = ref(null);
onMounted(async () => {
  // Проверяем, загружен ли Chart.js
  if (typeof Chart === 'undefined') {
    const scriptChart = document.createElement('script');
    scriptChart.src = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.9/dist/chart.umd.min.js';
    scriptChart.onload = () => {
      // После загрузки Chart.js подключаем плагин

      const scriptDatalabels = document.createElement('script');
      scriptDatalabels.src = 'https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.2.0/dist/chartjs-plugin-datalabels.min.js';
      scriptDatalabels.onload = getBarChart;
       document.head.appendChild(scriptDatalabels);
    };
    setTimeout(() => {
      document.head.appendChild(scriptChart);
    },200)
  } else {
    // Если Chart.js уже загружен, сразу подключаем плагин
    const scriptDatalabels = document.createElement('script');
    scriptDatalabels.src = 'https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.2.0/dist/chartjs-plugin-datalabels.min.js';
    scriptDatalabels.onload = getBarChart;
    document.head.appendChild(scriptDatalabels);
  }
});
</script>
<style lang="scss" scoped>
.graph {
  background-color: white;
  border-radius: 16px;
  padding: 24px 24px  10px 24px;

  &__title {
    font-weight: 600;
    font-size: 20px;
    color: $dark;
    margin-right: 155px;
  }

  &__description {
    font-size: 14px;
    color: $dark-blue;
    margin-top: 8px;
    margin-bottom: 20px;
  }

  &__graph {
    position: relative;
  }

  .no-data {
    height: 325px;
    width: 100%;
    color: $gray;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    text-align: center;
    border: 1px solid rgba(228, 231, 238, 1);
    border-radius: 12px;
  }
}
</style>